<div class="aza-cart-v2-container">
  <div class="aza-cart-v2-header aza-horizontal-stack">
    <div class="aza-cart-v2-tab-button-container aza-cart-v2-tab-button-container-cart">
      <button (click)="onCartTabSelected()"
        class="aza-cart-v2-tab-button aza-cart-v2-cart-tab-button aza-horizontal-stack aza-vertical-items-centered"
        [ngClass]="{'aza-cart-v2-tab-button-selected' : flags.cartItemsSelected, 'aza-cart-v2-tab-button-not-selected': !flags.cartItemsSelected}">
        <img src="assets/img/shopping-cart-v2/local_mall.png" class="aza-cart-v2-tab-button-image" />
        <span class="aza-cart-v2-tab-button-text" translate>SHOPPING_CART</span>
      </button>
    </div>
    <div class="aza-cart-v2-tab-button-container aza-cart-v2-tab-button-container-transactions">
      <button (click)="onTransactionsTabSelected()"
        class="aza-cart-v2-tab-button aza-cart-v2-transactions-tab-button aza-horizontal-stack aza-vertical-items-centered"
        [ngClass]="{'aza-cart-v2-tab-button-selected' : flags.transactionItemsSelected, 'aza-cart-v2-tab-button-not-selected': !flags.transactionItemsSelected}">
        <img src="assets/img/shopping-cart-v2/local_mall.png" class="aza-cart-v2-tab-button-image" />
        <span class="aza-cart-v2-tab-button-text" translate>TRANSACTIONS</span>
      </button>
    </div>
  </div>

  @if (flags.cartItemsSelected) {
    <div class="aza-cart-v2-product-items">
      <div class="aza-cart-v2-products-and-condensed-items-container">
        <div class="aza-cart-v2-products">
          @for (item of cartItems; track item.product.id) {
            @if (!item.hidden) {
              <div class="aza-cart-v2-product-row">
                <div class="aza-cart-v2-product-row-item product-name">
                  {{item.product.name}}
                </div>
                <div class="aza-cart-v2-product-row-item product-price">
                  @if (item.product.type === 'donation') {
                    <div class="aza-horizontal-stack aza-cart-v2-product-price-row aza-align-items-center">
                      <div class="aza-padding aza-horizontal-stack aza-cart-v2-product-price-controls">
                        <input (change)="onDonationPriceChanges(item.product.id, $event)" required type="number" name="price" [value]="getDonationProductParticipantPrice(item)" [min]="item.product.price"/>
                      </div>
                      <span>{{ '' |  addText:cartCurrency}}</span>
                    </div>
                  } @else {
                    {{item.product.price | twoDecNumber | addText:cartCurrency}}
                  }
                </div>
                <div class="aza-cart-v2-product-row-item product-quantity">
                  <div class="aza-cart-v2-product-quantity-controls">
                    @if (!item.soldOut) {
                      <button (click)="onCartItemQuantityDecreased(item)"
                      class="aza-cart-v2-product-quantity-control decrease-quantity">-</button>
                      <div class="aza-cart-v2-product-quantity-control selected-quantity">
                        {{item.selectedQuantity}}
                      </div>
                      <button (click)="onCartItemQuantityIncreased(item)"
                      class="aza-cart-v2-product-quantity-control increase-quantity">+</button>
                    } @else {
                      <span class="aza-cart-v2-product-sold-out-text" translate>SOLD_OUT</span>
                    }
                  </div>
                </div>
              </div>
            }
          }
          @if (cartData?.showDiscountCode) {
            <div class="aza-cart-v2-discount-code-container">
              <div class="aza-cart-v2-discount-code-input-container">
                <input [(ngModel)]="discountCode" class="aza-cart-v2-discount-code-input"
                  [placeholder]="'DISCOUNT_CODE' | translate" />
                  <button (click)="onApplyDiscoundCode()" class="aza-cart-v2-apply-discount-code-button">
                    <span translate>APPLY</span>
                  </button>
                </div>
                <div class="aza-field-validation-error discount-code-invalid">
                  @if (discountCodeInvalid) {
                    <span translate>INVALID_DISCOUNT_CODE</span>
                  }
                </div>
              </div>
            }
          </div>
          <div class="aza-cart-v2-condensed-items-container aza-vertical-stack">
            <div class="aza-cart-v2-condensed-items-title">
              <span translate>ORDER_SUMMARY</span>
            </div>
            @for (condensedItem of cartResultUI.condensedItems; track condensedItem.product.id) {
              <div
                class="aza-cart-v2-condensed-item-row aza-vertical-items-centered">
                <div class="aza-cart-v2-condensed-item-quantity-with-name aza-vertical-items-centered">
                  <div class="aza-cart-v2-condensed-item-quantity justify-self-end">
                    {{condensedItem.quantity}}
                  </div>
                  <div class="aza-cart-v2-condensed-item-multiply-sign">x</div>
                  <div class="aza-cart-v2-condensed-item-name">{{condensedItem.product_name}}</div>
                </div>
                <!-- <div class="condensed-item-unit-price justify-self-end monospace-font">{{condensedItem.unit_price |
              twoDecNumber}}</div> -->
              <div class="aza-cart-v2-condensed-item-value">
                <div class="aza-cart-v2-condensed-item-row-subtotal">
                  {{condensedItem.subtotal | twoDecNumber | addText:cartCurrency}}
                </div>
              </div>
            </div>
          }
          @if (cartResultUI.totals.cancellation_cost) {
            <div class="aza-cart-v2-condensed-item-row">
              <div class="aza-cart-v2-cancellation-cost-label">
                <span translate>CANCELLATION_COST</span>
              </div>
              <div class="aza-cart-v2-condensed-item-value">
                <div class="aza-cart-v2-condensed-item-cancellation-cost-value">
                  <span>{{cartResultUI.totals.cancellation_cost | twoDecNumber | addText:cartCurrency}}</span>
                </div>
              </div>
            </div>
          }
          @if (cartResultUI.totals.other) {
            <div class="aza-cart-v2-condensed-item-row">
              <div class="aza-cart-v2-condensed-item-other-label">
                <span translate>OTHER</span>
              </div>
              <div class="aza-cart-v2-condensed-item-value">
                <div class="aza-cart-v2-condensed-item-other-value">
                  <span>{{cartResultUI.totals.other | twoDecNumber | addText:cartCurrency}}</span>
                </div>
              </div>
            </div>
          }
          @if (cartData?.showDiscountCode && cartResultUI.totals.total_discount !== 0) {
            <div class="aza-cart-v2-condensed-item-row">
              <div class="aza-cart-v2-condensed-item-discount-label">
                <span translate>DISCOUNT</span>
              </div>
              <div class="aza-cart-v2-condensed-item-value">
                <div class="aza-cart-v2-condensed-item-total-discount-value">
                  <span>{{cartResultUI.totals.total_discount | twoDecNumber | addText:cartCurrency}}</span>
                </div>
              </div>
            </div>
          }
          <div class="aza-cart-v2-condensed-item-row aza-cart-v2-condensed-item-total-row">
            <div class="aza-cart-v2-total-label">
              <span translate>TOTAL</span>
            </div>
            <div class="aza-cart-v2-condensed-item-value">
              <div class="aza-cart-v2-condensed-item-total-value">
                <span>{{cartResultUI.totals.total | twoDecNumber | addText:cartCurrency}}</span>
              </div>
            </div>
          </div>
          <div class="aza-cart-v2-condensed-item-row aza-cart-v2-condensed-item-paid-row">
            <div class="aza-cart-v2-paid-label">
              <span translate>{{translations.PAID}}</span>
            </div>
            <div class="aza-cart-v2-condensed-item-value">
              <div class="aza-cart-v2-condensed-item-paid-value">
                <span>{{cartResultUI.totals.paid | twoDecNumber | addText:cartCurrency}}</span>
              </div>
            </div>
          </div>
          <div class="aza-cart-v2-condensed-item-row aza-cart-v2-condensed-item-to-pay-refund-container">
            <div class="aza-cart-v2-condensed-item-to-pay-refund-label-container">
              @if (cartResultUI.totals.current_order_total < 0) {
                <span
                class="aza-cart-v2-condensed-item-refund-label" translate>REFUND</span>
              }
              @if (cartResultUI.totals.current_order_total >= 0) {
                <span
                class="aza-cart-v2-condensed-item-to-pay-label" translate>TO_PAY</span>
              }
            </div>
            <div class="aza-cart-v2-condensed-item-value">
              <div class="aza-cart-v2-condensed-item-to-pay-refund-value-container aza-horizontal-stack aza-vertical-items-centered">
                @if (cartResultUI.totals.current_order_total < 0) {
                  <span
                    class="aza-cart-v2-condensed-item-refund-value">{{-cartResultUI.totals.current_order_total
                  | twoDecNumber}}</span>
                  <span> {{cartCurrency}}</span>
                }
                @if (cartResultUI.totals.current_order_total >= 0) {
                  <span
                    class="aza-cart-v2-condensed-item-to-pay-value">{{cartResultUI.totals.current_order_total
                  | twoDecNumber}}</span>
                  <span> {{cartCurrency}}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (cartData?.productRespone?.pay_by_invoice) {
    <div
      class="section-form-single-column aza-section aza-theme aza-form">
      <div class="aza-section-colors">
        <div class="aza-form-field-area">
          <div class="aza-input-field">
            <div class="aza-field-content aza-field-type-select">
              <div class="shopping-card-pay-by-method">
                <label class="aza-text" translate>PAYMENT_TYPE</label> <span [class.aza-text-error]="!(selectedPayByOption?.id)">(*)</span>
                <div>
                  <select
                    (change)="onPayByInvoiceChanged()"
                    [(ngModel)]="selectedPayByOption"
                    class="shopping-card-pay-by-method-select"
                    required>
                    <option></option>
                    @for (option of payByOptions; track option.id) {
                      @if (payByVisibilityMap?.[option.id]) {
                        <option [ngValue]="option">
                          {{option.value}}
                        </option>
                      }
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="aza-cart-v2-transactions-container">
    <div class="aza-cart-v2-order-items-overview-container">
      <div
        class="aza-cart-v2-order-items-container aza-cart-v2-order-items-container-card-view aza-vertical-stack">
        @if (!flags.showTransactions) {
          <div class="aza-cart-v2-show-transactions-card-view-container">
            <button (click)="onShowTransactions()" class="aza-cart-v2-show-trancations-card-view-button">
              <span translate>VIEW_TRANSACTIONS</span>
            </button>
          </div>
        }
        @if (flags.showTransactions && cartResultUI?.currentOrder?.orderItems) {
          <aza-rws-shopping-cart-v2-order-items-card-view
            [orderItems]="cartResultUI.currentOrder.orderItems" [orderTotal]="cartResultUI.currentOrder.total"
            [cartCurrency]="cartCurrency">
            <span aza-cart-v2-order-items-card-view-title translate>CURRENT_ORDER</span>
          </aza-rws-shopping-cart-v2-order-items-card-view>
        }

        @if (flags.showTransactions && cartResultUI.order?.orderItems) {
          <aza-rws-shopping-cart-v2-order-items-card-view
            [orderItems]="cartResultUI.order.orderItems" [orderTotal]="cartResultUI.order.total"
            [cartCurrency]="cartCurrency">
            <span aza-cart-v2-order-items-card-view-title translate>PREVIOUS_TRANSACTIONS</span>
          </aza-rws-shopping-cart-v2-order-items-card-view>
        }

        @if (flags.showTransactions) {
          <div class="aza-cart-v2-hide-transactions-card-view-container">
            <button (click)="onHideTransactions()" class="aza-cart-v2-hide-trancations-card-view-button">
              <span translate>HIDE_TRANSACTIONS</span>
            </button>
          </div>
        }
      </div>

      <div
        class="aza-cart-v2-order-items-container aza-cart-v2-order-items-container-table-view aza-vertical-stack">
        @if (flags.showTransactions && cartResultUI?.currentOrder?.orderItems) {
          <aza-rws-shopping-cart-v2-order-items-table-view
            [orderItems]="cartResultUI.currentOrder.orderItems" [orderTotal]="cartResultUI.currentOrder.total"
            [cartCurrency]="cartCurrency">
            <span aza-cart-v2-order-items-table-view-title translate>CURRENT_ORDER</span>
          </aza-rws-shopping-cart-v2-order-items-table-view>
        }

        @if (flags.showTransactions && cartResultUI.order?.orderItems) {
          <aza-rws-shopping-cart-v2-order-items-table-view
            [orderItems]="cartResultUI.order.orderItems" [orderTotal]="cartResultUI.order.total"
            [cartCurrency]="cartCurrency">
            <span aza-cart-v2-order-items-table-view-title translate>PREVIOUS_TRANSACTIONS</span>
          </aza-rws-shopping-cart-v2-order-items-table-view>
        }
      </div>
    </div>
  </div>
</div>





@if (false) {
  <div class="aza-vertical-stack">
    <div class="header-items-container aza-horizontal-stack">
      <div class="cart-items-container aza-half-padding">
        <div class="name-column">
          <span translate>NAME</span>
        </div>
        <div class="price-column justify-self-end">
          <span translate>PRICE</span>
        </div>
        <div class="quantity-column justify-self-end">
          <span translate>QUANTITY</span>
        </div>
        @for (item of cartItems; track item.product.id) {
          @if (!item.hidden) {
            <div [ngClass]="{'display-none': item.hidden}" class="item-name">
              {{item.product.name}}
            </div>
            <div [ngClass]="{'display-none': item.hidden}" class="item-pricej justify-self-end monospace-font">
              {{item.product.price | twoDecNumber}}
            </div>
            <div [ngClass]="{'display-none': item.hidden}" class="item-quantity justify-self-end">
              <input (input)="onCartItemQuantityChanged(item, $event)" [value]="item.selectedQuantity"
                type="number" [attr.min]="item.minQuantity" [attr.max]="item.quantityConstrained ? item.maxQuantity : null" />
              </div>
            }
          }
        </div>
        <div class="dynamic-data-container aza-vertical-stack">
          <div class="condensed-items-container aza-half-padding">
            <div class="name-column">
              <span translate>NAME</span>
            </div>
            <div class="price-column justify-self-end">
              <span translate>UNIT_PRICE</span>
            </div>
            <div class="quantity-column justify-self-end">
              <span translate>QUANTITY</span>
            </div>
            <div class="price-column justify-self-end">
              <span translate>SUBTOTAL</span>
            </div>
            @for (condensedItem of cartResultUI.condensedItems; track condensedItem.product.id) {
              <div class="condensed-item-name">{{condensedItem.product_name}}</div>
              <div class="condensed-item-unit-price justify-self-end monospace-font">{{condensedItem.unit_price |
              twoDecNumber}}</div>
              <div class="condensed-item-quantity justify-self-end monospace-font">{{condensedItem.quantity}}
              </div>
              <div class="condensed-item-subtotal justify-self-end monospace-font">{{condensedItem.subtotal |
              twoDecNumber}}</div>
            }
            @if (cartResultUI.totals.cancellation_cost) {
              <div class="cancellation-cost-label aggregate-condensed-items-grid-label justify-self-end">
                <span translate>CANCELLATION_COST</span>
              </div>
              <div class="cancellation-cost-value justify-self-end monospace-font">
                <span>{{cartResultUI.totals.cancellation_cost | twoDecNumber}}</span>
              </div>
            }
            @if (cartResultUI.totals.other) {
              <div class="other-label aggregate-condensed-items-grid-label justify-self-end">
                <span translate>OTHER</span>
              </div>
              <div class="other-value justify-self-end monospace-font">
                <span>{{cartResultUI.totals.other | twoDecNumber}}</span>
              </div>
            }
            <div class="total-label aggregate-condensed-items-grid-label justify-self-end">
              <span translate>DISCOUNT</span>
            </div>
            <div class="bold-value justify-self-end monospace-font">
              <span>{{cartResultUI.totals.total_discount | twoDecNumber}}</span>
            </div>
            <div class="total-label aggregate-condensed-items-grid-label justify-self-end">
              <span translate>TOTAL</span>
            </div>
            <div class="bold-value justify-self-end monospace-font">
              <span>{{cartResultUI.totals.total | twoDecNumber}}</span>
            </div>
            <div class="refund-label aggregate-condensed-items-grid-label justify-self-end">
              @if (cartResultUI.totals.current_order_total < 0) {
                <span translate>REFUND</span>
              }
              @if (cartResultUI.totals.current_order_total >= 0) {
                <span translate>TO_PAY</span>
              }
            </div>
            <div class="refund-value bold-value justify-self-end monospace-font">
              @if (cartResultUI.totals.current_order_total < 0) {
                <span>{{-cartResultUI.totals.current_order_total
                | twoDecNumber}}</span>
              }
              @if (cartResultUI.totals.current_order_total >= 0) {
                <span>{{cartResultUI.totals.current_order_total
                | twoDecNumber}}</span>
              }
            </div>
          </div>
          <div>
            @if (!flags.showTransactions) {
              <button (click)="onShowTransactions()">
                <span translate>SHOW_TRANSACTIONS</span>
              </button>
            }
          </div>
        </div>
      </div>
      @if (cartData?.productRespone?.pay_by_invoice) {
        <div
          class="section-form-single-column aza-section aza-theme aza-form">
          <div class="aza-section-colors">
            <div class="aza-form-field-area">
              <div class="aza-input-field">
                <div class="aza-field-content aza-field-type-select">
                  <div class="shopping-card-pay-by-method">
                    <label class="aza-text" translate>PAYMENT_TYPE</label> <span [class.aza-text-error]="!(selectedPayByOption?.id)">(*)</span>
                    <div>
                      <select
                        (change)="onPayByInvoiceChanged()"
                        [(ngModel)]="selectedPayByOption"
                        class="shopping-card-pay-by-method-select"
                        required>
                        <option></option>
                        @for (option of payByOptions; track option.id) {
                          <option [ngValue]="option">
                            {{option.value}}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (cartData?.showDiscountCode) {
        <div class="discount-code-container">
          <div class="discount-code-input-container aza-horizontal-stack">
            <label for="shopping-cart-v2-discount-code-input-label" translate>DISCOUNT_CODE</label>
            <input (input)="onDiscountCodeInput($any($event.target).value)" id="shopping-cart-v2-discount-code-input"
              class="shopping-cart-v2-discount-code-input" />
            </div>
            <div class="aza-field-validation-error discount-code-invalid">
              @if (discountCodeInvalid) {
                <span translate>INVALID_DISCOUNT_CODE</span>
              }
            </div>
          </div>
        }
        @if (flags.showTransactions) {
          @if (cartResultUI?.currentOrder?.orderItems) {
            <div
              class="current-order-overview-container order-items-overview-container">
              <div class="order-items-overview-title">
                <span translate>CURRENT_ORDER</span>
              </div>
              <div class="current-order-container">
                <div class="date-column">
                  <span translate>DATE</span>
                </div>
                <div class="name-column">
                  <span translate>NAME</span>
                </div>
                <div class="price-column justify-self-end">
                  <span translate>UNIT_PRICE</span>
                </div>
                <div class="quantity-column justify-self-end">
                  <span translate>QUANTITY</span>
                </div>
                <div class="discount-column justify-self-end">
                  <span translate>DISCOUNT</span>
                </div>
                <div class="tax-column justify-self-end">
                  <span translate>TAX</span>
                </div>
                <div class="price-column justify-self-end">
                  <span translate>SUBTOTAL</span>
                </div>
                @for (item of cartResultUI.currentOrder.orderItems; track item.id) {
                  <div class="current-order-item-date">{{item.transaction_date | eventDate}}</div>
                  <div class="current-order-item-name">{{item.product_name}}</div>
                  <div class="current-order-item-unit-price justify-self-end monospace-font">{{item.unit_price |
                  twoDecNumber}}</div>
                  <div class="current-order-item-quantity justify-self-end monospace-font">{{item.quantity}}
                  </div>
                  <div class="current-order-item-discount justify-self-end monospace-font">{{item.discount |
                  twoDecNumber}}</div>
                  <div class="current-order-item-tax justify-self-end monospace-font">{{item.tax |
                  twoDecNumber}}</div>
                  <div class="current-order-item-total justify-self-end monospace-font">{{item.total |
                  twoDecNumber}}</div>
                }
                <div class="aggregate-order-overview-grid-label justify-self-end">
                  <span translate>TOTAL</span>
                </div>
                <div class="current-order-total bold-value justify-self-end monospace-font">
                  <span>{{cartResultUI.currentOrder.total | twoDecNumber}}</span>
                </div>
              </div>
            </div>
          }
          @if (cartResultUI.order?.orderItems?.length) {
            <div
              class="existing-transaction-overview-container order-items-overview-container">
              <div class="order-items-overview-title">
                <span translate>PREVIOUS_TRANSACTIONS</span>
              </div>
              <div class="current-order-container">
                <div class="date-column">
                  <span translate>DATE</span>
                </div>
                <div class="name-column">
                  <span translate>NAME</span>
                </div>
                <div class="price-column justify-self-end">
                  <span translate>UNIT_PRICE</span>
                </div>
                <div class="quantity-column justify-self-end">
                  <span translate>QUANTITY</span>
                </div>
                <div class="discount-column justify-self-end">
                  <span translate>DISCOUNT</span>
                </div>
                <div class="tax-column justify-self-end">
                  <span translate>TAX</span>
                </div>
                <div class="price-column justify-self-end">
                  <span translate>SUBTOTAL</span>
                </div>
                @for (item of cartResultUI.order.orderItems; track item.id) {
                  <div class="current-order-item-date">{{item.transaction_date | eventDate}}</div>
                  <div class="current-order-item-name">{{item.product_name}}</div>
                  <div class="current-order-item-unit-price justify-self-end monospace-font">{{item.unit_price |
                    twoDecNumber}}
                  </div>
                  <div class="current-order-item-quantity justify-self-end monospace-font">{{item.quantity}}</div>
                  <div class="current-order-item-discount justify-self-end monospace-font">{{item.discount |
                    twoDecNumber}}
                  </div>
                  <div class="current-order-item-tax justify-self-end monospace-font">{{item.tax | twoDecNumber}}
                  </div>
                  <div class="current-order-item-total justify-self-end monospace-font">{{item.total | twoDecNumber}}
                  </div>
                }
                <div class="aggregate-order-overview-grid-label justify-self-end">
                  <span translate>TOTAL</span>
                </div>
                <div class="current-order-total bold-value justify-self-end monospace-font">
                  <span>{{cartResultUI.order.total | twoDecNumber}}</span>
                </div>
              </div>
            </div>
          }
        }
      </div>
    }
